import React from 'react';
import { Image, ImageBackground, View } from 'react-native';
import { useSelector } from 'react-redux';

import { pc_money } from '../../../assets/icons';
import leths_back from '../../../assets/images/leths_back.png';
import { AppHeader } from '../../../components/common';
import { GreenButton } from '../../../components/derivative';
import { AppText } from '../../../components/form';
import styles from './styles';

const CoinBank = ({ navigation }) => {
  const { workerData } = useSelector((state) => state.worker);

  return (
    <ImageBackground source={leths_back} style={styles.viewBase}>
      <AppHeader title="Saldo de Moedas" hasBack navigation={navigation} />
      <View style={styles.content}>
        <Image source={pc_money} style={styles.imageCoinBank} />
        <View style={styles.viewCoinBalance}>
          <AppText style={styles.textBalance} size="bold">SALDO</AppText>
          <View style={styles.viewCoinSubBalance}>
            <AppText style={styles.textBalanceNumber} size="bold">{workerData.saldo_moedas}</AppText>
            <AppText style={styles.textBalance}>MOEDAS</AppText>
          </View>
        </View>
        {/* <GreenButton label="RESGATAR" onPress={() => navigation.navigate('Worker Coin Claim')} /> */}
        <GreenButton label="HISTÓRICO" onPress={() => navigation.navigate('Worker Claim History')} />
      </View>
    </ImageBackground>
  );
};

export default CoinBank;
